import { useSectionCapability } from '@ingenico/react-section-utils';
import type { DeviceManagementCapabilities } from '../domain/models/capabilities.model';

export const useDeviceManagementCapability = useSectionCapability<DeviceManagementCapabilities>;
